import { render, staticRenderFns } from "./NbPostalCodeInput.vue?vue&type=template&id=1091b92a&"
import script from "./NbPostalCodeInput.vue?vue&type=script&lang=js&"
export * from "./NbPostalCodeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports